import {
  ErrorPresentation,
  customStringMinMaxValidation,
  requiredValidation,
} from 'helpers/validators';
import { noop } from 'shared/utils/function';
import { ValidationSchema } from '../types';
import {
  makeHandleFormValidation,
  onViewValidation,
  validate,
} from '../validation';
import {
  CreateLevelOnView,
  EditLevelOnView,
} from 'shared/domain/level/types/view';
import { FieldSize } from 'shared/types/fieldSize';

const validationSchema: ValidationSchema<CreateLevelOnView> = {
  ...onViewValidation,
  label: labelFieldValidation,
  site: siteFieldValidation,
  map: noop as (value: any) => ErrorPresentation,
};

export const handleFormValidation =
  makeHandleFormValidation(validationSchema);

export function validateLevel(
  key: keyof CreateLevelOnView,
  value: CreateLevelOnView[keyof CreateLevelOnView]
): ErrorPresentation {
  return validate(key, value, validationSchema);
}

function labelFieldValidation(value: any): ErrorPresentation {
  return (
    requiredValidation(value) ||
    customStringMinMaxValidation(1, FieldSize.S, value)
  );
}

function siteFieldValidation(
  site: CreateLevelOnView['site']
): ErrorPresentation {
  return requiredValidation(site?._id);
}

export function validateLevelOnViewEdit(
  key: keyof EditLevelOnView,
  value: EditLevelOnView[keyof EditLevelOnView]
): ErrorPresentation {
  if (key === '_id') {
    return;
  }
  return validate(key, value, validationSchema);
}
